/* src/app/orders/retail/confirm-place-order/confirm-place-order.component.scss */
/*# sourceMappingURL=confirm-place-order.component.css.map */
